import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { CheckoutCatalogKey } from './checkout.i18n.js';
import { CHECKOUT_CATALOG } from './checkout.i18n.js';

export type CheckoutMessageId = `checkout:${CheckoutCatalogKey}`;

const PREFIX_LENGTH = 'checkout:'.length;

/** `t()` for the stop-gap `checkout:` scope (see `checkout.i18n.ts`). */
export function useCheckoutT(): { t: (id: CheckoutMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: CheckoutMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as CheckoutCatalogKey;
      const raw = CHECKOUT_CATALOG[locale][key] ?? CHECKOUT_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
